import React, { useEffect, useState, } from 'react'
import Swal from 'sweetalert2';
import { auth, db } from '../../firebase';
import "../../App.css";
import { collection, query, orderBy, onSnapshot, getDoc, doc, limit } from 'firebase/firestore'
import moment from 'moment';

export default function Userlogs() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);

    const [logs, setlogs] = useState([]);
    const [searchText, setsearchText] = useState("");


    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);



    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchPropid()
        });
    });

    const fetchPropid = async () => {
        if (userData) {
            if (loadincount) {
                const docRef = doc(db, "users", userData.uid)
                const docSnap = await getDoc(docRef)
                if (docSnap.exists()) {
                    fetchData1();
                    setloadincount(false)
                }
            }
        }
    }

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, 'logs'), orderBy('createdAt', 'desc'), limit(500))
            onSnapshot(q, (querySnapshot) => {
                setlogs(querySnapshot.docs.map(doc => {
                    const data = doc.data();
                    return {
                        id: doc.id,
                        data: {
                            ...data,
                            createdAt: data.createdAt ? moment(data.createdAt.toDate()).format('DD/MM/YYYY hh:mm:ss A') : null // Converts Firestore Timestamp to JavaScript Date
                        }
                    };
                }));
               
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = logs.filter((item) =>
                item.data.username.toUpperCase().includes(searchText.toUpperCase())
            );
            setlogs(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }



    return (
        <div>
            <div className="content-wrapper">
                <br />

                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| User Logs ||</button><br /><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className=" p-1">
                                &nbsp;&nbsp;<input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4' placeholder='Type here......' />&nbsp;
                            </div>
                            <div className="card-body table-responsive p-0" >

                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Datetime </th>
                                            <th>User Name </th>
                                            <th>Type </th>
                                            <th>Customer Name </th>
                                            <th>Customer Mobile </th>
                                            <th>Action </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            logs.map((item, num = 1) =>
                                                <tr key={num + 1}>
                                                    <td width="80">{num + 1}</td>
                                                    <td>{item.data.createdAt}</td>
                                                    <td>{item.data.username}</td>
                                                    <td>{item.data.type}</td>
                                                    <td>{item.data.customers.custname}</td>
                                                    <td>{item.data.customers.mobile}</td>
                                                    <td>
                                                        <a href={'view-details/' + item.data.bookingid} className='btn btn-info btn-sm'><i className="fa fa-eye"></i></a>&nbsp;

                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


        </div>
    )
}
